import AstDatepicker from "../modules/ast-datepicker/AstDatepicker";
import errorToast from "../modules/error-toast/errorToast";
import TabLayout from "../modules/TabLayout";

// The initialize Datepicker for input duration in sidebar
const inputFields = document.querySelectorAll(".cd-sidebar__input-field-value");
for (let el of inputFields) {
  new AstDatepicker({
    field: el,
    trigger: el.nextElementSibling,
    dateFormat: "DD MMM YY",
    minDate: "today",
    locale: "id"
  });
}

// This is for handling empty input value in sidebar
const sidebarForms = document.querySelectorAll(".cd-sidebar__form");
for (let el of sidebarForms) {
  el.addEventListener("submit", e => {
    const startDate = el.querySelector("[name=start_date]");
    const duration = el.querySelector("[name=duration]");

    if (startDate.value.length < 1) {
      e.preventDefault();
      errorToast(
        "Tanggal peminjaman belum diisi",
        el.querySelector(".start-date"),
        3000
      );
      return;
    } else if (duration.value.length < 1) {
      e.preventDefault();
      errorToast("Durasi peminjaman belum diisi", duration, 3000);
      return;
    }

    if (document.body.classList.contains("production")) {
      e.preventDefault();
      return gtag_report_conversion({
        conversionID: "AW-702169517/LZdiCLnGobEBEK2D6c4C",
        callback: () => el.submit()
      });
    }
  });
}

window.onload = () => {
  // The initialize TabLayout for facilities tab in sidebar
  new TabLayout(".tab-layout", { adaptiveHeight: true });
};
